import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { fetchUserProfile } from '../services';

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const base_url = "https://api.slipstreaminvoices.com";
  const [token, setToken] = useState(() => {
    return localStorage.getItem('slipstream_token') || null;
  });
  const [user, setUser] = useState(null);
  const [company, setCompany] = useState(null);
  const [authReady, setAuthReady] = useState(() => !localStorage.getItem('slipstream_token'));
  const [statusToast, setStatusToast] = useState(null);

  const clearSession = useCallback(() => {
    setToken(null);
    setUser(null);
    setCompany(null);
    localStorage.removeItem('slipstream_token');
  }, []);

  useEffect(() => {
    if (!token) {
      setUser(null);
      setCompany(null);
      setAuthReady(true);
      return;
    }

    let cancelled = false;
    setAuthReady(false);

    (async () => {
      try {
        await fetchUserProfile(token, base_url, setUser, setCompany);
      } catch (error) {
        console.error('Failed to restore session:', error);
        if (!cancelled) {
          clearSession();
        }
      } finally {
        if (!cancelled) {
          setAuthReady(true);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [token, base_url, clearSession]);

  const showStatus = useCallback((type, message) => {
    setStatusToast({ type, message, id: Date.now() });
  }, []);

  const dismissStatus = useCallback(() => {
    setStatusToast(null);
  }, []);

  return (
    <AppContext.Provider value={{
      base_url,
      token, setToken,
      user, setUser,
      company, setCompany,
      authReady,
      clearSession,
      statusToast, showStatus, dismissStatus,
    }}>
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within an AppProvider');
  }
  return context;
};
